// Small profile icon shown next to each chat message.
// - Rook: portrait crop (hallway warm)
// - Falco: his real photo
// - Rainer (Phase 3): his portrait
// Fallback: initial letter in amber circle.

import type { CSSProperties } from "react";

type Identity = 'rook' | 'falco' | 'rainer' | string;

interface AvatarProps {
  identity: Identity;
  size?: number;
}

const PORTRAITS: Record<string, string> = {
  // Image 4 — armchair portrait. Rook's signature avatar per Falco.
  rook: '/images/rook-portrait.png',
  // Persona art, not the real photo.
  falco: '/images/falco-persona.png',
  rainer: '/images/rainer-casual.jpg',
};

export function Avatar({ identity, size = 28 }: AvatarProps) {
  const src = PORTRAITS[identity.toLowerCase()];
  const initial = identity.charAt(0).toUpperCase();

  if (!src) {
    return (
      <div
        className="avatar avatar-fallback"
        style={{
          "--avatar-size": `${size}px`,
          fontSize: size * 0.5,
        } as CSSProperties}
      >
        {initial}
      </div>
    );
  }

  // Rook's portrait crops better from the upper-center of the image.
  const objectPosition = identity.toLowerCase() === 'rook' ? '50% 25%' : 'center';

  return (
    <img
      src={src}
      alt={identity}
      className="avatar"
      style={{ "--avatar-size": `${size}px`, objectPosition } as CSSProperties}
    />
  );
}
